import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
export function NotImplemented() {
    const { t } = useTranslation();
    return (_jsx(Stack, Object.assign({ flexGrow: "1", justifyContent: "center", alignItems: "center" }, { children: _jsx(Typography, Object.assign({ color: "primary" }, { children: _jsx(_Fragment, { children: t('not_implemented') }) })) })));
}
